import { render, staticRenderFns } from "./Demo3.vue?vue&type=template&id=1c7e2bbb&scoped=true"
import script from "./Demo3.vue?vue&type=script&lang=js"
export * from "./Demo3.vue?vue&type=script&lang=js"
import style0 from "./Demo3.vue?vue&type=style&index=0&id=1c7e2bbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7e2bbb",
  null
  
)

export default component.exports